import { Box, Typography, styled } from '@mui/material';

export const StickyLineContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  paddingBottom: '12px',
  position: 'sticky',
  top: '-1px',
  zIndex: 5,
  width: '100%',
  background: theme.palette.case.neutral.n75,
}));

export const StickyLineTextContainer = styled(Box, {
  shouldForwardProp: (prop: string) => !['svgFill'].includes(prop),
})<{ svgFill?: string }>(({ svgFill = 'initial' }) => ({
  display: 'flex',
  alignItems: 'center',
  svg: { width: '20px', height: '20px', path: { fill: svgFill } },
}));

export const StickyLineText = styled(Typography)(({ theme }) => ({
  color: theme.palette.case.neutral.n900,
  padding: '0 12px 0 4px',
}));

export const StickyDashedLine = styled(Box, {
  shouldForwardProp: (prop: string) => !['variantBorder'].includes(prop),
})<{ variantBorder?: string }>(({ theme, variantBorder = 'dashed' }) => ({
  marginRight: '8px',
  borderTop: `1px ${variantBorder} ${theme.palette.case.neutral.n200}`,
  width: '100%',
  marginTop: '1px',
}));
